import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  employees: [],
  employee: {},
  flights: {},
  team_groups: [],
  car_groups: [],
  flight_groups: [],
  eatting_tables: [],
  totalEmployee: 0,
  totalRelationship: 0,
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  listEmployeeSummerTrip: [],
  groupSummerTrip: [],
  carSummerTrip: [],
  flightSummerTrip: [],
  dataMaster: [],
  category: {}
};

// getters
export const getters = {
  listEmployeeSummerTrip: state => state.listEmployeeSummerTrip,
  totalEmployee: state => state.totalEmployee,
  totalRelationship: state => state.totalRelationship,
  pagination: state => state.pagination,
  flights: state => state.flights,
  team_groups: state=>state.team_groups,
  car_groups: state => state.car_groups,
  flight_groups: state => state.flight_groups,
  eatting_tables: state => state.eatting_tables,
  groupSummerTrip: state => state.groupSummerTrip,
  carSummerTrip: state => state.carSummerTrip,
  flightSummerTrip: state => state.flightSummerTrip,
  dataMaster: state => state.dataMaster,
  category: state => state.category
};

// mutations
export const mutations = {
  [types.EMPLOYEE.FETCH_EMPLOYEE](state, data) {
    state.employees = data.employees;
    state.pagination.from = data.employees.from;
    state.pagination.to = data.employees.to;
    state.pagination.totalPage = data.employees.last_page;
    state.pagination.path = data.employees.path;
    state.pagination.currentPage = data.employees.current_page;
    state.pagination.totalRecord = data.employees.total;
    state.pagination.perPage = data.employees.per_page;
    state.logAction = data.resultLogAction;
  },

  [types.EMPLOYEE_SUMMER_TRIP.GET_EMPLOYEE_SUMMER_TRIP](state, data) {
    state.listEmployeeSummerTrip = data.data;
    state.pagination.from = data.from;
    state.pagination.to = data.to;
    state.pagination.totalPage = data.last_page;
    state.pagination.path = data.path;
    state.pagination.currentPage = data.current_page;
    state.pagination.totalRecord = data.total;
    state.pagination.perPage = data.per_page;
    state.totalEmployee = data.user_company,
    state.totalRelationship = data.user_relative
  },
  [types.EMPLOYEE_SUMMER_TRIP.LIST_FLIGHT_DETAIL](state, data) {
    state.flights = data
  },
  [types.EMPLOYEE_SUMMER_TRIP.GET_TEAM_NAMES](state, data) {
    state.team_groups = data.TEAM;
    state.car_groups = data.CAR;
    state.flight_groups = data.FLIGHT;
    state.dataMaster = data;
  },

  [types.EMPLOYEE_SUMMER_TRIP.GET_SUMMER_TRIP_FOR_OVERVIEW](state, data) {
    state.groupSummerTrip = data.group;
    state.carSummerTrip = data.car;
    state.flightSummerTrip = data.flight;
    state.flightSummerTrip = data.flight;
    state.eatting_tables = data.eatting_tables;
  },
  [types.EMPLOYEE_SUMMER_TRIP.GET_SUMMER_TRIP_MASTER_DETAIL](state, data) {
    state.category = data
  }
};

// actions
export const actions = {
  async fetchEmployee({ commit }, payload) {
    const response = await axios.get(api.LIST_EMPLOYEE_SUMMER_TRIP, {
      params: {
        name: payload.name,
        per_page: payload.optionPage,
        page: payload.currentPage,
        team: payload.team,
        car:  payload.car,
        flight:  payload.flight,
        company: payload.company,
        relative: payload.relative,
        columnSort: payload.columnSort,
        sortBy: payload.sortBy,
        eatting_table: payload.eatting_table
      }
    });
    commit(types.EMPLOYEE_SUMMER_TRIP.GET_EMPLOYEE_SUMMER_TRIP, response.data);
  },

  async fetchFlightDetail({ commit }) {
    const response = await axios.get(api.LIST_FLIGHT_DETAIL);
    commit(types.EMPLOYEE_SUMMER_TRIP.LIST_FLIGHT_DETAIL, response.data);
  },

  async fetchSummerTripTeams({ commit }) {
    const response = await axios.get(api.LIST_TEAM_NAMES);
    commit(types.EMPLOYEE_SUMMER_TRIP.GET_TEAM_NAMES, response.data);
  },

  async fetchSummerTripForOverview({ commit }) {
    const response = await axios.get(api.GET_SUMMER_TRIP_FOR_OVERVIEW);
    commit(types.EMPLOYEE_SUMMER_TRIP.GET_SUMMER_TRIP_FOR_OVERVIEW, response.data);
  },
  // async fetchSummerTripForOverview({ commit }) {
  //   const response = await axios.get(api.GET_SUMMER_TRIP_FOR_OVERVIEW);
  //   commit(types.EMPLOYEE_SUMMER_TRIP.GET_SUMMER_TRIP_FOR_OVERVIEW, response.data);
  // },
  async getSummerTripMasterDetail({ commit }, payload) {
    const response = await axios.get(api.GET_SUMMER_TRIP_MASTER_DETAIL+`/${payload}`);
    commit(types.EMPLOYEE_SUMMER_TRIP.GET_SUMMER_TRIP_MASTER_DETAIL, response.data);
  },
  async updateSummerTripMaster(_, payload) {
    // const response = await axios.post(api.UPDATE_SUMMER_TRIP_MASTER+`/${payload.id}`, payload);
    await axios.post(api.UPDATE_SUMMER_TRIP_MASTER+`/${payload.id}`, payload);
  },
};
